import React from "react";
import { motion } from "framer-motion";
import { FaStar, FaQuoteLeft, FaUser } from "react-icons/fa";
import "./Testimonials.css";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Priya Sharma",
      rating: 5,
      text: "Dr. Satya is an exceptional cardiologist. His expertise and compassionate care helped me through a difficult time. The clinic staff is also wonderful.",
      service: "Cardiac Consultation",
    },
    {
      name: "Rajesh Kumar",
      rating: 5,
      text: "The stress test was thorough and well-explained. Dr. Satya took time to answer all my questions and put me at ease.",
      service: "Stress Test",
    },
    {
      name: "Anjali Patel",
      rating: 5,
      text: "I've been coming here for preventive care for years. Dr. Satya's preventive approach has kept my heart healthy.",
      service: "Preventive Cardiology",
    },
    {
      name: "Vikram Singh",
      rating: 5,
      text: "Excellent ECG service. Quick, painless, and the results were explained clearly. Highly recommend this clinic.",
      service: "ECG",
    },
    {
      name: "Meera Reddy",
      rating: 5,
      text: "The echocardiography was performed with precision. Dr. Satya's attention to detail is remarkable.",
      service: "Echocardiography",
    },
    {
      name: "Arjun Verma",
      rating: 5,
      text: "Outstanding care from start to finish. The clinic is modern, clean, and the staff is professional and friendly.",
      service: "Heart Checkup",
    },
  ];

  const renderStars = (rating) =>
    [...Array(5)].map((_, index) => (
      <FaStar key={index} className={index < rating ? "star filled" : "star"} />
    ));

  return (
    <div className="testimonials-page">
      <section className="testimonials-hero">
        <div className="container">
          <motion.div
            className="testimonials-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 style={{ fontSize: "1.8rem" }}>Patient Testimonials</h1>
            <p style={{ fontSize: "var(--font-size-base)" }}>
              Hear from our patients about their experience with SATYA HEART
              CLINIC
            </p>
          </motion.div>
        </div>
      </section>

      <div className="container">
        <section className="testimonials-section section">
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                className="testimonial-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="testimonial-header">
                  <FaQuoteLeft className="quote-icon" />
                  <div className="rating">
                    {renderStars(testimonial.rating)}
                  </div>
                </div>

                <p className="testimonial-text">{testimonial.text}</p>

                <div className="testimonial-footer">
                  <div className="patient-info">
                    <div className="patient-avatar">
                      <FaUser />
                    </div>
                    <div>
                      <h4>{testimonial.name}</h4>
                      <span className="service">{testimonial.service}</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        <section className="trust-section section">
          <motion.div
            className="trust-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2>Trusted by Thousands of Patients</h2>
            <p>
              Our commitment to excellence in cardiac care has earned us the
              trust of patients throughout the region.
            </p>
            <div className="trust-stats">
              <div className="trust-stat">
                <h3>10,000+</h3>
                <p>Happy Patients</p>
              </div>
              <div className="trust-stat">
                <h3>15+</h3>
                <p>Years Experience</p>
              </div>
              <div className="trust-stat">
                <h3>100%</h3>
                <p>Patient Satisfaction</p>
              </div>
            </div>
          </motion.div>
        </section>
      </div>
    </div>
  );
};

export default Testimonials;
